import { Component, Input, OnInit } from '@angular/core';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.css']
})
export class HistorialComponent implements OnInit {

  @Input() simulacion: boolean;
  dataJardin = new JardinModel();
  uniEducativa = new UnidadEducativaModel(); 
  historialData:any; 
  
  constructor(private api: apiService) { }

  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.historial(this.dataJardin);
  }


  unidadEducativa(dataJardin:JardinModel){
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }

  historial(dataJardin:JardinModel){
    this.api.API_POST_obtenerHistorial(dataJardin.rbd).subscribe((response: ResponseUnidadEducativaModel) => {
      this.historialData = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }
}
